import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 配置 axios 实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：添加认证令牌
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理认证错误
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export interface LoginResponse {
  success: boolean;
  message: string;
  token: string;
  user: {
    id: number;
    name: string;
    role: string;
  };
  error?: string;
}

export interface VerifyResponse {
  success: boolean;
  user: {
    id: number;
    name: string;
    role: string;
  };
  error?: string;
}

export const authService = {
  // 用户登录
  async login(username: string, password: string): Promise<LoginResponse> {
    try {
      const response = await apiClient.post('/auth/login', {
        username,
        password,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || '登录请求失败');
    }
  },

  // 验证令牌
  async verifyToken(): Promise<VerifyResponse> {
    try {
      const response = await apiClient.get('/auth/verify');
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || '令牌验证失败');
    }
  },

  // 用户登出
  async logout(): Promise<void> {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      console.error('登出请求失败:', error);
    }
  },
};

export { apiClient };